export const downloadHelper = {
    methods: {
        downloadFile: function (response, fileName) {
            var blob = new Blob([response.data],
                {type: response.headers['Content-Type']})
            if (window.navigator.msSaveOrOpenBlob) { // For I.E.
                navigator.msSaveBlob(blob, fileName)
            } else { // For other browsers:
                var link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = fileName
                document.body.appendChild(link)
                link.click()
                setTimeout(function () {
                    document.body.removeChild(link)
                    window.URL.revokeObjectURL(link.href)
                }, 0)
            }
        },
        downloadZipFile: function (response, fileName) {
            try {
                // Create a Blob from the response
                const blob = new Blob([response.data], { type: 'application/zip' });

                // Create a link element, set its download attribute, and trigger it
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName; // Set the name of the file to be downloaded
                link.click();

                // Cleanup the link element after triggering the download
                window.URL.revokeObjectURL(link.href);
            } catch (error) {
                //eslint-disable-next-line
                console.error('Error during file download:', error);
            }
        },
        getCommonReportParams: function (params) {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            params.time_zone = timeZone
            params.locale = this.$i18n.locale
            return params
        },
        downloadBase64Image: function (base64String, fileName = 'image.jpg') {
            const [meta, data] = base64String.split(',')
            const type = meta.split(':')[1].split(';')[0]
            const bytes = Uint8Array.from(atob(data), c => c.charCodeAt(0))
            const blob = new Blob([bytes], { type })
            
            if (window.navigator.msSaveOrOpenBlob) { // For I.E.
                navigator.msSaveBlob(blob, fileName)
            } else {
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = fileName
                document.body.appendChild(link)
                link.click()
                setTimeout(() => {
                    document.body.removeChild(link)
                    window.URL.revokeObjectURL(link.href)
                }, 0)
            }
        }
    }
}
